var map = {
	"./10s": 2364,
	"./10s.json": 2364,
	"./20s": 89650,
	"./20s.json": 89650,
	"./30s": 68433,
	"./30s.json": 68433,
	"./Blitz": 37107,
	"./Blitz.json": 37107,
	"./Bullet": 13145,
	"./Bullet.json": 13145,
	"./CaissaHello_animation.riv": 72442,
	"./CaissaSuccess_animation.riv": 39880,
	"./Calculation_Trainer/Calculation_Trainer": 79409,
	"./Calculation_Trainer/Calculation_Trainer.json": 79409,
	"./Challenge_a_friend.riv": 38960,
	"./Classical": 61845,
	"./Classical.json": 61845,
	"./Didnt_find_any_opponent.riv": 78280,
	"./Intuition_Trainer/Intuition_Trainer": 47517,
	"./Intuition_Trainer/Intuition_Trainer.json": 47517,
	"./Play_against_Caissa_Bot.riv": 86596,
	"./Play_random_opponent.riv": 14715,
	"./Practice_from_a_position.riv": 73820,
	"./Rapid": 71178,
	"./Rapid.json": 71178,
	"./Search": 38949,
	"./Search.json": 38949,
	"./Snail": 99040,
	"./Snail.json": 99040,
	"./Solve_Puzzles/Solve_Puzzles": 99282,
	"./Solve_Puzzles/Solve_Puzzles.json": 99282,
	"./Square_Trainer/Square_training": 19919,
	"./Square_Trainer/Square_training.json": 19919,
	"./Start_new_game/v1": 67339,
	"./Start_new_game/v1.json": 67339,
	"./Start_new_game/v2": 46004,
	"./Start_new_game/v2.json": 46004,
	"./caissa_animation.riv": 53305,
	"./challenge_animation.riv": 74939,
	"./challenge_wait": 72226,
	"./challenge_wait.json": 72226,
	"./chessboardLoader": 89433,
	"./chessboardLoader.json": 89433,
	"./chessboardLoader2": 31222,
	"./chessboardLoader2.json": 31222,
	"./circlechess_opponent_matching_animation.riv": 9111,
	"./didnt_respond.riv": 53680,
	"./error_boundary_animation": 99901,
	"./error_boundary_animation.json": 99901,
	"./error_page_404.lottie": 58014,
	"./mobileMenuIcon": 93785,
	"./mobileMenuIcon.json": 93785,
	"./rejected_your_challenge.riv": 19680,
	"./successCheck": 2752,
	"./successCheck.json": 2752,
	"./under_construction": 70973,
	"./under_construction.json": 70973
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95502;